import { render, staticRenderFns } from "./CommentDetail.vue?vue&type=template&id=1c4de3f0&scoped=true"
import script from "./CommentDetail.vue?vue&type=script&lang=js"
export * from "./CommentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4de3f0",
  null
  
)

export default component.exports